import React, {useEffect, useState, useContext} from 'react';
import {queryTransactions, averageTransactions} from "../../Services/api";
import Grid from "@mui/material/Grid";
import {store} from "../../store";
import {formatNumber} from "../../helpers/utils/utils";
import {mergeQuery} from "../../Services/querys";
import SalaryFigure from "./SalaryFigure";
import {hasScope, SCOPES} from "../../helpers/scopes";
import {Figure} from "./Figure";
import HorizontalScroll from "../../atoms/HorizontalDisplay/HorizontalScroll";

export default function Figures({query}) {
  const {state} = useContext(store);
  const canReadCosts = hasScope(state.user, SCOPES.ROTA_COST_READ) && hasScope(state.user, SCOPES.ROTA_ADMIN_READ);

  let [data, setData] = useState({
    totalPrice:'-',
    tax:'-',
    afterTax:'-',
    cost: '-',
    loading:true
  });
  let [takeaway, setTakeaway] = useState('-');
  let [transAvg, setTransAvg] = useState('-');

  useEffect(() => {
    if (query.from && state.site._id) {
      setData((prevState => {
        return {...prevState, loading: true
        }
      }));
      queryTransactions(mergeQuery(query,{group:'none', fields:'totalPrice,tax,cost'})).then(data => {
        if (data.data && data.data.length) {
          setData((prevState => {
            return {...prevState,
              totalPrice:data.data[0].totalPrice,
              tax:data.data[0].tax,
              afterTax: data.data[0].totalPrice - data.data[0].tax,
              cost: data.data[0].cost,
              loading: false
            }
          }));
        } else{
          setData((prevState => {
            return {...prevState, totalPrice:0, tax:0, afterTax:0, cost:0, loading: false
            }
          }));
        }
      });

      queryTransactions(mergeQuery(query,{group:'none', fields:'totalPrice', filter: `tags:[Takeaway]`})).then(data => {
        if (data.data && data.data.length) {
          setTakeaway(data.data[0].totalPrice);
        } else {
          setTakeaway(0);
        }
      });

      averageTransactions(mergeQuery(query,{group:'orderId'})).then(data => {
        if (data.data) {
          if (data.data.length && data.data[0].average){
            setTransAvg(data.data[0]);
          } else {
            setTransAvg(0);
          }
        }
      });
    }
  }, [query, state.site, state.user]);

  return (
    <React.Fragment>
      <HorizontalScroll>
        <Grid
          size={{
            md: 4,
            sm: 4,
            xs: 4
          }}>
          <Figure heading={'Revenues'}
                  unit={'£'}
                  loading={data.loading}
                  mainNumber={formatNumber(data.totalPrice, data.totalPrice > 10000 ? 0 : 2)}
                  message={`£${formatNumber(data.afterTax, data.afterTax > 10000 ? 0 : 2, true)} excl. vat`} />
        </Grid>
        {canReadCosts &&
          <Grid
            size={{
              md: 4,
              sm: 4,
              xs: 4
            }}>
            <SalaryFigure siteId={state.site._id} from={query.from} to={query.to} sales={data.loading ? null : data.totalPrice} />
          </Grid>
        }
        <Grid
          size={{
            md: 4,
            sm: 4,
            xs: 4
          }}>
          <Figure heading={'Inventory Cost'}
                  unit={'£'}
                  loading={data.loading}
                  mainNumber={formatNumber(data.cost, data.cost > 10000 ? 0 : 2)}
                  message={`${formatNumber((data.cost/data.totalPrice*100), 1)}% of Sales`} />
        </Grid>
        <Grid
          size={{
            md: 4,
            sm: 4,
            xs: 4
          }}>
          <Figure heading={'Average Transaction'}
                unit={'£'}
                mainNumber={formatNumber(transAvg.average)}
                message={`${formatNumber(transAvg.count, 0)} Orders`} />
        </Grid>

        {state.site && state.site.normalName === 'lochinver-larder' &&
        <React.Fragment>
          <Grid
            size={{
              md: 4,
              sm: 4,
              xs: 4
            }}>
            <Figure heading={'Pies Sold'}
                    unit={''}
                    mainNumber={formatNumber(state.totalPies.quantity, 0)}
                    message={`£${formatNumber((state.totalPies.totalPrice), state.totalPies.totalPrice > 10000 ? 0 : 2)}`} />
          </Grid>
          <Grid
            size={{
              md: 4,
              sm: 4,
              xs: 4
            }}>
            <Figure heading={'Takeaway Sales'}
                  unit={'£'}
                  mainNumber={formatNumber(state.takeaway || takeaway, (state.takeaway || takeaway) > 10000 ? 0 : 2)}
                  message={`${formatNumber(((state.takeaway || takeaway)/data.totalPrice*100), 1)}% of Sales`} />
          </Grid>
          </React.Fragment>
        }
      </HorizontalScroll>
    </React.Fragment>
  );
}
